import React, { useEffect, useState } from "react";
import CountUp from "./CountUp";

// Premium monoline radial gauge for the Growth Score.
export default function GaugeScore({ value = 0, size = 240, stroke = 14, max = 100, label = "Growth Score" }) {
  const radius = (size - stroke) / 2;
  const cx = size / 2;
  const cy = size / 2;
  // 270deg arc (gap at bottom)
  const startAngle = 135;
  const sweep = 270;
  const circ = 2 * Math.PI * radius;
  const arcLen = (sweep / 360) * circ;
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const t = setTimeout(() => setProgress(value / max), 120);
    return () => clearTimeout(t);
  }, [value, max]);

  const polar = (angle) => {
    const a = (angle - 90) * (Math.PI / 180);
    return { x: cx + radius * Math.cos(a), y: cy + radius * Math.sin(a) };
  };
  const p0 = polar(startAngle);
  const p1 = polar(startAngle + sweep);
  const largeArc = sweep > 180 ? 1 : 0;
  const trackPath = `M ${p0.x} ${p0.y} A ${radius} ${radius} 0 ${largeArc} 1 ${p1.x} ${p1.y}`;

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size}>
        <path d={trackPath} fill="none" stroke="#EDEEE9" strokeWidth={stroke} strokeLinecap="round" />
        <path
          d={trackPath}
          fill="none"
          stroke="#93C020"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={arcLen}
          strokeDashoffset={arcLen * (1 - progress)}
          style={{ transition: "stroke-dashoffset 1.5s cubic-bezier(.16,1,.3,1)" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <div className="flex items-baseline">
          <CountUp value={value} className="text-6xl font-extrabold tracking-tighter text-ink" />
          <span className="text-xl font-semibold text-ink-3 ml-1">/ {max}</span>
        </div>
        <span className="label-caps mt-1">{label}</span>
      </div>
    </div>
  );
}
